import React, { useState } from 'react'
import { Select, Typography, Row, Col, Avatar, Card } from 'antd'
import moment from 'moment'
import { useGetCryptoNewsQuery } from '../services/cryptoNewsApi'
import { useGetCryptosQuery } from '../services/cryptoApi'
import Loader from './Loader';

const { Text, Title } = Typography;
const { Option } = Select
const demoImage = 'https://images.livemint.com/img/2022/02/04/1600x900/Cryptocurrency_prices_today_1643946385625_1643946385776.jpg'
const News = ({ simplified }) => {
  const [newsCategory, setNewsCategory] = useState('Cryptocurrency')
  const { data: cryptoNews } = useGetCryptoNewsQuery({ newsCategory, count: simplified ? 6 : 12 })
  const {data} = useGetCryptosQuery(100); 
  console.log(cryptoNews)

  if (!cryptoNews?.value) return <Loader/>
  return (
    <>
    {!simplified &&(
      <Col span={24}>
        <Select style={{marginBottom:'2rem'}}
        showSearch 
        className='select-news' 
        placeholder="Select a Crypto" 
        optionFilterProp='children' 
        onChange={(value)=> setNewsCategory(value) }
        filterOption={(input,option)=>option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0 }
        >
       
        <Option value="Cryptocurrency" >Cryptocurrency</Option>
       {data?.data?.coins.map((coin)=> <Option value={coin.name} >{coin.name}</Option>)}
       
       </Select>
      </Col>
    )}

      <Row gutter={[24, 24]} >
        {cryptoNews.value.map((news, i) => (
          <Col xs={24} sm={12} lg={8} key={i} >
            <Card hoverable className='news-card'>
              <a href={news.url} target="_blank" rel="noreferrer">
                <div className="news-image-container">
                  <Title className='news-title' level={4} >{news.name  > 12
                  ? `${news.name.substring(0,12)}...`
                  : news.name }</Title>
                  <img style={{maxWidth:'100px', maxHeight:'100px'}} alt="news" src={news?.image?.thumbnail?.contentUrl || demoImage} />
                </div>
                <p>
                {news.description > 100
                  ? `${news.description.substring(0,100)}...`
                  : news.description
                }
                </p>

                <div className="provider-container">
                 <Avatar src={news.provider[0]?.image?.thumbnail?.contentUrl || demoImage} > </Avatar>
                 <Text>{moment(news.datePublished).startOf('ss').fromNow()}</Text> 
                 </div>
              </a>
            </Card>
          </Col>)
        )}
      </Row>
    </>
  )
}

//Exporting
export default News